import { Errno } from '@puppycad/proto';

/**
 * API 协议错误。
 *
 * 用于承载后端在流式事件或业务响应中返回的 Errno，避免把协议错误退化成普通字符串错误。
 */
export class ApiErrnoError extends Error {
  /**
   * 后端协议错误码。
   */
  public readonly errno: Errno;

  /**
   * 创建 API 协议错误。
   *
   * @param errno 后端协议错误码。
   * @param message 调试上下文消息，最终用户文案由 Errno 中文映射统一决定。
   */
  public constructor(errno: Errno, message = 'API 返回协议错误') {
    super(message);
    this.name = 'ApiErrnoError';
    this.errno = errno;
  }
}
